import api from '../api';

import { ParamsDataActiveProduct } from 'utils/typeServices';

export const GetActiveProducts = async (NR_PLATAFORMA: string) => {
    const token = localStorage.getItem('token');

    try {
        const { data } = await api.get<{ Data: Array<ParamsDataActiveProduct> }>(`v1/Plataforma/GetActiveProducts?NR_PLATAFORMA=${NR_PLATAFORMA}`, {
            headers: {
                'Authorization': 'Bearer ' + token,
            }
        });

        return data.Data;
    } catch (error) {
        console.error('error', error);
        return null;
    }
}
